export const REF_TYPE_OFFER = 'offer';
export const REF_TYPE_SHOWCASE = 'showcase';

// triggers
export const NOT_SELECTED = 'not_selected';

export const PAGE_OPEN = 'page_open';
export const PAGE_CLOSE = 'page_close';

export const OPEN_DELAY = 'open_delay';
export const INACTIVITY_DELAY = 'inactivity_delay';
export const WIDGET_VISIBILITY_DELAY = 'widget_visibility_delay';

export const SCROLL_UP = 'scroll_up';
export const SCROLL_DOWN = 'scroll_down';

export const BUTTON_BACK = 'button_back';

// const AFTER_ANY_CLICK = 'after_any_click';
export const AFTER_WIDGET_CLICK = 'after_widget_click';

// fonts
export const FONT_INTER = 'Inter';
export const FONT_MONTSERRAT = 'Montserrat';
export const FONT_ROBOTO = 'Roboto';
export const FONT_RALEWAY = 'Raleway';
export const FONT_UBUNTU = 'Ubuntu';
export const FONT_OPEN_SANS = 'Open Sans';
export const FONT_RUBIK = 'Rubik';
export const FONT_MERRIWEATHER = 'Merriweather';
export const FONT_LORA = 'Lora';
export const FONT_PT_SERIF = 'PT Serif';
export const FONT_NOTO_SERIF = 'Noto Serif';
export const FONT_ROBOTO_SLAB = 'Roboto Slab';

export const ALL_FONTS = [
    FONT_LORA,
    FONT_MERRIWEATHER,
    FONT_MONTSERRAT,
    FONT_NOTO_SERIF,
    FONT_OPEN_SANS,
    FONT_PT_SERIF,
    FONT_RALEWAY,
    FONT_ROBOTO,
    FONT_ROBOTO_SLAB,
    FONT_RUBIK,
    FONT_UBUNTU,
];

// типы виджетов
export const SHOWCASE_TYPE = 'embedded-showcase';
export const BANNER_TYPE = 'banner';
export const POPUP_BANNER_TYPE = 'popup-banner';
export const POPUP_OFFERS_TYPE = 'popup-offers';